import { FunnelPlusIcon } from "lucide-react";
import React from "react";
import { useDispatch } from "react-redux";

import { IgButton } from "@intelligems/ig-theme";
import { ButtonProps } from "@mui/material";
import { openDrawer } from "@src/store/slices/drawers";

export const FiltersButton = ({ ...props }: ButtonProps) => {
  const dispatch = useDispatch();

  return (
    <IgButton
      data-testid="analytics-filters-button"
      onClick={() => {
        dispatch(openDrawer({ type: "analyticsFilters" }));
      }}
      sx={{ minWidth: "0" }}
      variant="outlined"
      {...props}
    >
      <FunnelPlusIcon size={16} />
    </IgButton>
  );
};
